module.exports = __webpack_public_path__ + "img/page55.dd4396b9.gif";